<template>
    <TheContainer :key="$page.props.locale">
        <slot />
        <flash-message />
        <!-- Modals used in the application -->
        <curie-id-scanner />
        <unsaved-changes-modal />
        <inoperable-test-blocked-modal />
        <!-- End of Modals -->
        <sticky-bottom-sheet />
    </TheContainer>
</template>
<script setup>
import TheContainer from '@/Containers/TheContainer.vue';
import FlashMessage from '@/Components/FlashMessage.vue';
import CurieIdScanner from '@/Components/CurieIdScanner.vue';
import StickyBottomSheet from '@/Components/StickyBottomSheet.vue';
import UnsavedChangesModal from '@/Pages/Locations/UnsavedChangesModal.vue';
import InoperableTestBlockedModal from '@/Components/InoperableTestBlockedModal.vue';
</script>
